module.exports = __webpack_public_path__ + "static/media/trustwallet.edcc1ab5.png";